<template>
	<div class="action-checklist--item">
		<div>
			<Icon
				:icon="icon"
				:color="color"
			/>
		</div>
		<div class="">
			<template v-if="status === 'done'">
				<span v-if="confirmationDate">
					<b>{{ type }}</b> am <b>{{ confirmationDate | date }}</b> bestätigt
				</span>
				<span v-else>
					<b>{{ type }}</b> bestätigt
				</span>
			</template>
			<span v-else-if="status === 'questionable'">
				<b>{{ type }} hochgeladen, Prüfung durch skilldoo offen</b>
			</span>
			<span v-else-if="status === 'open'">
				<b>{{ type }} noch nicht bestätigt</b>
			</span>
		</div>
		<div v-if="status === 'open' && withConfirmNow">
			<Button
				text="Jetzt bestätigen"
				smaller
				@click="$emit('confirmNow')"
			/>
		</div>
	</div>
</template>

<script>
import Button from "@/vue/common/Button";
import Icon from "@/vue/icon/Icon";

const STATUS_OPEN = 'open';
const STATUS_QUESTIONABLE = 'questionable';
const STATUS_DONE = 'done';

const ICONS = {
	[STATUS_OPEN]: 'close',
	[STATUS_QUESTIONABLE]: 'question-circle',
	[STATUS_DONE]: 'checkmark',
};

const COLORS = {
	[STATUS_OPEN]: 'red',
	[STATUS_QUESTIONABLE]: 'yellow',
	[STATUS_DONE]: 'green',
};

export default {

	components: {
		Icon,
		Button,
	},

	props: {
		type: {
			type: String,
			required: true,
		},
		status: {
			type: String,
			required: true,
		},
		confirmationDate: {
			type: String,
			required: false,
		},
		withConfirmNow: {
			type: Boolean,
			required: false,
			default: true,
		}
	},

	computed: {
		icon ()
		{
			return ICONS[this.status];
		},
		color ()
		{
			return COLORS[this.status];
		},
	}
}
</script>
